import { cn } from '@/lib/utils';

import { forwardRef } from 'react';
import { Toolbar, ToolbarProps } from './toolbar';

const FixedToolbar = forwardRef<HTMLDivElement, ToolbarProps>(({ className, ...props }: ToolbarProps, ref) => {
  return (
    <Toolbar
      ref={ref}
      className={cn(
        'supports-backdrop-blur:bg-background/60 border-b-border bg-background/95 w-full justify-between overflow-x-auto rounded-t-lg border-b backdrop-blur',
        className
      )}
      {...props}
    />
  );
});
FixedToolbar.displayName = 'FixedToolbar';

export { FixedToolbar };
